import * as React from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import SnackbarBase from '@components/basics/snackbar';
import Typography from '@components/basics/typography';
import DismissIcon from '@components/basics/icons/dismiss';

export interface SnackbarNotificationProps {
  className?: string;
  title: string;
  text: React.ReactNode;
  actionText?: string;
  btnText?: string;
  hasDismiss?: boolean;
  onAction?: () => void;
  onClick?: () => void;
}

export const SnackbarNotification: React.FC<SnackbarNotificationProps> = (
  props
) => {
  return (
    <div className={props.className}>
      <SnackbarBase
        className="snackbar-notification"
        isCentered
        content={
          <>
            <Title weight="700">{props.title}</Title>
            <Text>{props.text}</Text>
          </>
        }
        actions={
          <Flex
            justifyContent="flex-end"
            alignItems="center"
            className="actions"
          >
            {props.btnText ? (
              <ActionText weight="700" onClick={props.onClick}>
                {props.btnText}
              </ActionText>
            ) : null}
            {props.hasDismiss ? (
              <StyledDismissIcon onClick={props.onAction} />
            ) : null}
          </Flex>
        }
      />
    </div>
  );
};

export default styled(SnackbarNotification)`
  .snackbar-notification {
    width: 100%;
    user-select: none;
    padding: 20px;
    box-shadow: ${({ theme }) =>
      `${theme.general.boxShadow} ${theme.colors.shadow}`};
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 4px;

    .actions-wrapper {
      width: 100%;
      .actions {
        justify-content: space-between;
      }
    }

    .text-wrapper {
      width: 100%;
      justify-content: flex-start;
    }

    @media ${({ theme }) => theme.device.tablet} {
      padding: 30px;

      .text-wrapper {
        flex-basis: 70%;
        width: auto;
      }

      .actions-wrapper {
        flex-basis: 30%;
        width: auto;
        .actions {
          justify-content: flex-end;
        }
      }
    }
  }

  .actions-text {
    cursor: pointer;
    opacity: 1;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      opacity: 0.5;
    }
  }
`;

const Title = styled(Typography)`
  color: ${({ theme }) => theme.colors.background};
  display: inline-block;
  margin-right: 10px;
`;

const Text = styled(Typography)`
  color: ${({ theme }) => theme.colors.background};
  opacity: 0.8;
  display: inline-block;
`;

const ActionText = styled(Typography)`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.background};
  opacity: 1;
  transition: opacity
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    opacity: 0.75;
  }
`;

const StyledDismissIcon = styled(DismissIcon)`
  @media ${({ theme }) => theme.device.tablet} {
    margin-left: 30px;
  }
`;
